import React from 'react';
import { Link } from 'react-router-dom';
import { Check, X, ArrowRight } from 'lucide-react';

const rows = [
  { feature: 'AI Analysis Real-time', tradiora: true, other: false },
  { feature: 'Paper Trading (Simulasi)', tradiora: true, other: false },
  { feature: 'Akademi Trading Lengkap', tradiora: true, other: false },
  { feature: 'Mentoring 1-on-1', tradiora: true, other: false },
  { feature: 'Komunitas Trader Aktif', tradiora: true, other: true },
  { feature: 'Investment Journal', tradiora: true, other: false },
  { feature: 'Multi-Asset (Saham & Crypto)', tradiora: true, other: true },
  { feature: 'Notifikasi Pasar Real-time', tradiora: true, other: false },
  { feature: 'Laporan Performa Bulanan', tradiora: true, other: false },
  { feature: 'Biaya Berlangganan', tradiora: 'Gratis', other: 'Mulai Rp 299K/bln' },
];

function Comparison() {
  return (
    <section className="comparison" style={{ padding: '100px 0', background: 'var(--surface)' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block-text center" style={{ marginBottom: 48 }}>
              <h3 className="heading">Kenapa Tradiora?</h3>
              <p className="fs-20" style={{ color: 'var(--text)', maxWidth: 550, margin: '12px auto 0' }}>
                Lebih banyak fitur, lebih terjangkau. Bandingkan sendiri dan lihat perbedaannya.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12">
            <div style={{
              background: 'var(--bg)',
              borderRadius: 20,
              border: '1px solid var(--line)',
              overflow: 'hidden',
              boxShadow: '0 4px 24px rgba(0,0,0,0.04)',
            }}>
              {/* Header */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1.5fr 1fr 1fr',
                borderBottom: '2px solid var(--line)',
              }}>
                <div style={{ padding: '22px 28px', fontWeight: 600, fontSize: 12, color: 'var(--text)', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Fitur
                </div>
                <div style={{
                  padding: '22px 28px', fontWeight: 800, fontSize: 15, color: '#fff',
                  background: 'linear-gradient(135deg, #0C8F86, #087a72)',
                  textAlign: 'center', letterSpacing: '0.5px',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                    Tradiora
                    <span style={{
                      background: 'rgba(255,255,255,0.2)', borderRadius: 4, padding: '2px 6px',
                      fontSize: 9, fontWeight: 600,
                    }}>GRATIS</span>
                  </div>
                </div>
                <div style={{ padding: '22px 28px', fontWeight: 600, fontSize: 12, color: 'var(--text)', textAlign: 'center', letterSpacing: '0.5px' }}>
                  Platform Lain
                </div>
              </div>

              {/* Rows */}
              {rows.map((row, index) => (
                <div
                  key={index}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1.5fr 1fr 1fr',
                    borderBottom: index < rows.length - 1 ? '1px solid var(--line)' : 'none',
                    background: index % 2 === 0 ? 'transparent' : 'var(--surface)',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(12,143,134,0.03)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = index % 2 === 0 ? 'transparent' : 'var(--surface)'; }}
                >
                  <div style={{ padding: '18px 28px', fontSize: 14, color: 'var(--onsurface)', fontWeight: 500 }}>
                    {row.feature}
                  </div>
                  <div style={{
                    padding: '18px 28px', textAlign: 'center',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    {typeof row.tradiora === 'boolean' ? (
                      row.tradiora ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Check size={16} color="#58bd7d" />
                          <span style={{ color: '#58bd7d', fontSize: 14, fontWeight: 700 }}>Ada</span>
                        </div>
                      ) : (
                        <X size={16} color="#ef4444" />
                      )
                    ) : (
                      <span style={{ color: '#58bd7d', fontSize: 14, fontWeight: 700, background: 'rgba(88,189,125,0.1)', padding: '4px 12px', borderRadius: 8 }}>
                        {row.tradiora}
                      </span>
                    )}
                  </div>
                  <div style={{
                    padding: '18px 28px', textAlign: 'center',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    {typeof row.other === 'boolean' ? (
                      row.other ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Check size={16} color="#ef4444" />
                          <span style={{ color: 'var(--text)', fontSize: 13 }}>Ada</span>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <X size={15} color="#ef4444" />
                          <span style={{ color: '#ef4444', fontSize: 12 }}>Tidak</span>
                        </div>
                      )
                    ) : (
                      <span style={{ color: '#ef4444', fontSize: 13, fontWeight: 600 }}>
                        {row.other}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div style={{
              textAlign: 'center', marginTop: 36,
              background: 'linear-gradient(135deg, rgba(12,143,134,0.05), rgba(139,92,246,0.05))',
              borderRadius: 16, padding: '32px 40px',
              border: '1px solid rgba(12,143,134,0.1)',
            }}>
              <p style={{ color: 'var(--text)', fontSize: 15, marginBottom: 16 }}>
                Daftar gratis sekarang dan nikmati semua fitur unggulan tanpa biaya awal.
              </p>
              <Link
                to="#download"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: 'linear-gradient(135deg, #0C8F86, #087a72)',
                  color: '#fff', fontWeight: 700, fontSize: 15,
                  borderRadius: 14, padding: '14px 32px', textDecoration: 'none',
                  boxShadow: '0 8px 30px rgba(12,143,134,0.3)',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(12,143,134,0.4)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = '';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(12,143,134,0.3)';
                }}
              >
                Mulai Gratis Sekarang
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Comparison;
